export const user = {
  add: { label: "Ajouter un utilisateur" },
  activity: "Activité",
  activityPlural: "Activités",
  lastLoginAt: "Dernière connexion",
  stateUpdatedAt: "Mis à jour d'état",
  role: "Rôle",
  rolePlural: "Rôles",
  subject: "Sujet",
  permission: "Permission",
  permissionPlural: "Permissions",
  removePermission: "Enlever la permission",
  otherPermissions: "Autre permissions",
  organizationRole: {
    super: {
      label: "Super administateur",
      description: "Cet utilisateur peut gérer toutes les organisations.",
    },
    admin: {
      label: "Administrateur",
      description: "Cet utilisateur peut gérer son organisation.",
    },
    user: {
      label: "Utilisateur",
      description:
        "Cet utilisateur peut voir son organisation et gérer tous les éléments à l'intérieur de celle-ci.",
    },
    noRole: {
      label: "Aucune permission pour {{organization}}",
      description:
        "Cet utilisateur ne pourra pas utiliser les fonctionnalités de l'application.",
    },
  },
  delete: {
    label: "Supprimer l'utilisateur",
  },
  forceChangePassword: {
    info: "Vous vous apprêtez à réinitialiser le mot de passe de {{name}}. Ce dernier sera déconnecté et devra changer son mot de passe avant de pouvoir se connecter à nouveau.",
    button: "Réinitialiser le mot de passe",
    error: "Une erreur est survenue. Veuillez réessayer plus tard.",
    success: "Mot de passe réinitialisé avec succes.",
  },
  form: {
    name: { label: "Nom" },
    email: { label: "Courriel" },
    organization: { label: "Organisation" },
    mainRole: { label: "Rôle principal sur cette organisation" },
    updatePassword: { label: "Changer le mot de passe" },
    oldPassword: { label: "Ancien mot de passe" },
    newPassword: { label: "Nouveau mot de passe" },
    newPasswordConfirmation: { label: "Confirmation du mot de passe" },
    resetCode: { label: "Code de réinitialisation" },
  },
  preferences: {
    changePassword: {
      title: "Étape 2: changer le mot de passe",
      error:
        "Une erreur est survenue. Le mot de passe n’a pu être changé. Veuillez réessayer plus tard.",
      success: "Votre mot de passe a été changé avec succès.",
    },
    notifications: {
      channels: {
        database: "Panneau de notification",
        broadcast: "Notification en temps réel",
        mail: "Courriel",
      },
      genericNotificationsTitle: "Notifications générales",
      moduleNotificationsTitle: "Rapports et modules",
      updateSuccess: "Vos préférences ont été mises à jour avec succès.",
    },
    resetCode: {
      info: "Un code sera envoyé à votre adresse courriel afin que vous puissiez compléter le formulaire à l’étape 2 et changer votre mot de passe.",
      title: "Étape 1: récupérer un code de réinitialisation",
      success:
        "Un code de réinitialisation vous a été envoyé. Veuillez consulter vos courriels.",
    },
    tabs: {
      general: {
        label: "Général",
      },
      notifications: {
        label: "Notifications",
      },
      password: {
        label: "Mot de passe",
      },
    },
  },
  resendInvite: {
    button: "Renvoyer l'invitation",
    error: "Une erreur est survenue. Veuillez réessayer plus tard.",
    success: "Invitation envoyée avec succès.",
  },
  resetMFA: {
    label: "Réinitialiser AMF",
    info: "Vous vous apprêtez à réinitialiser l'AMF de {{name}}. L’utilisateur recevra un courriel avec un mot de passe temporaire pour lui permettre de réinitialiser son compte.",
  },
};
